import {
  mutationNames
} from '@/store/storeKeysettings'
import { convertBoolean, IsDevSim } from '@/modules/helper/index'
const defaultContentPage = {
  Parent: {
    'Id': '',
    'PageTitle': '',
    'RowCreated': null,
    'RowUpdated': null,
    'SubscriptionModuleActivation_Id': 0,
    'HeaderElements': '',
    'FooterElements': '',
    'UseCategories': false,
    'AllowLikes': false,
    'AllowComments': true,
    'ConfirmComments': false,
    'AllowSharing': false,
    'PostCategories': '',
    'ShowPostHeaderOnDetailPage': true,
    'AllowAddingToFavorites': false,
    'POIInitalMapLocation': null,
    'POIInitialZoomLevel': null,
    'POIInitialShowList': false
  },
  'ContentPages': []
}
const state = {
  ContentPage: Object.assign({}, defaultContentPage),
  UserComment: {
    'Id': '',
    'RowCreated': '',
    'RowUpdated': '',
    'RowDeleted': false,
    'ModulesContentPagesPosts_Id': 0,
    'CommentDate': '',
    'CommentAuthor': '',
    'Comment': '',
    'CommentEmail': ''
  },
  SelectedContenttab: '',
  ActiveCategory: '',
  NewContentPage: null,
  POIMarkerAddressArr: []
}

const mutations = {
  [mutationNames.SET_CONTENT_PAGES](state, ContentPage) {
    state.ContentPage = ContentPage
  },
  [mutationNames.SET_ACTIVECATEGORY](state, ActiveCategory) {
    state.ActiveCategory = ActiveCategory
  },

  [mutationNames.SET_CONTENT_PAGE_PARENT](state, parent) {
    state.ContentPage.Parent = parent
  },
  [mutationNames.SET_CONTENTPAGESPOSTS](state, posts) {
    state.ContentPage.Posts = posts
  },
  [mutationNames.SET_USERCOMMENT](state, payload) {
    state.UserComment = payload
  },
  [mutationNames.UPDATE_USERCOMMENT](state, payload) {
    state.UserComment = Object.assign({}, state.UserComment, payload)
  },
  [mutationNames.UPDATE_CONTENTPAGEPARENT](state, parent) {
    state.ContentPage.Parent = parent
  },
  [mutationNames.UPDATE_CONTENTPAGES](state, ContentPages) {
    state.ContentPage.ContentPages = ContentPages
  },
  [mutationNames.ADD_USERCOMMENT](state, payload) {
    for (let _contentPage of state.ContentPage.ContentPages) {
      for (let _post of _contentPage.Posts) {
        if (_post.Id === payload.comment.ModulesContentPagesPosts_Id) {
          _post.PostComments.unshift(payload.comment)
          break
        }
      } 
    }
  },
  [mutationNames.ADD_POSTLIKE](state, payload) {
    for (let _contentPage of state.ContentPage.ContentPages) {
      for (let _post of _contentPage.Posts) {
        if (_post.Id === payload.Reference_Id) {
          _post.IsLiked = payload.Liked
          payload.Liked ? _post.PostLikes++ : _post.PostLikes--
          break
        }
      }
    }
  },
  [mutationNames.SET_SELECTED_CONTENT_TAB](state, value) {
    state.SelectedContenttab = value
  },
  [mutationNames.CREATE_NEW_CONTENT_PAGE](state, contentPage) { // Use only when devsim reflection shows.
    state.NewContentPage = contentPage
  },
  ADD_POI_ADDRESS(state, payload) { // Use only when devsim reflection shows.
    state.POIMarkerAddressArr = payload
  }
}

const actions = {
  initContentPageData: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_CONTENT_PAGES, payload)
  },
  resetContentPageData: ({
    commit
  }) => {
    commit(mutationNames.SET_CONTENT_PAGES, Object.assign({}, defaultContentPage))
  },
  initContentPageParentData: ({
    commit
  }) => {
    commit(mutationNames.SET_CONTENT_PAGE_PARENT)
  },
  initContentPagePostsData: ({
    commit
  }) => {
    commit(mutationNames.SET_CONTENTPAGESPOSTS)
  },
  updateUserCommentData: ({
    commit
  }, payload) => {
    commit(mutationNames.UPDATE_USERCOMMENT, payload)
  },
  addPostComment: async({
    commit
  }, payload) => {
    commit(mutationNames.ADD_USERCOMMENT, payload)
  },
  setSelectedContentTab: ({
    commit
  }, payload) => {
    commit(mutationNames.SET_SELECTED_CONTENT_TAB, payload)
  },
  setNewContentPage: ({ commit }, contentPage) => { // Use only when devsim reflection shows.
    commit(mutationNames.CREATE_NEW_CONTENT_PAGE, contentPage)
  },
  setActiveCategory: ({ commit }, category) => {
    commit(mutationNames.SET_ACTIVECATEGORY, category)
  },
  setPOIMarkerAddressArr: ({ commit }, payload) => { // Use only when devsim reflection shows.
    commit('ADD_POI_ADDRESS', payload)
  }
}

const getters = {
  ContentPage: state => {
    return {
      Parent: state.ContentPage.Parent ? state.ContentPage.Parent : Object.assign({}, defaultContentPage.Parent),
      ContentPages: state.ContentPage.ContentPages
                    .filter(page => {
                      return IsDevSim() ? page.Posts.filter(post => !convertBoolean(post.RowDeleted)).length > 0 : page.Posts.filter(post => !convertBoolean(post.RowDeleted) && convertBoolean(post.Active)).length > 0
                    })
                    .map(page => {
                      return {
                        ...page,
                        Posts: IsDevSim() ? page.Posts.filter(post => !convertBoolean(post.RowDeleted)) : page.Posts.filter(post => !convertBoolean(post.RowDeleted) && convertBoolean(post.Active))
                      }
                    })
    }
  },
  ContentPageForAll: state => { // Bcs in text module not needed publishing functionality
    return {
      Parent: state.ContentPage.Parent ? state.ContentPage.Parent : Object.assign({}, defaultContentPage.Parent),
      ContentPages: state.ContentPage.ContentPages
                    .filter(page => {
                      return page.Posts.filter(post => !convertBoolean(post.RowDeleted) && convertBoolean(post.Active)).length > 0
                    })
                    .map(page => {
                      return {
                        ...page,
                        Posts: page.Posts.filter(post => !convertBoolean(post.RowDeleted) && convertBoolean(post.Active))
                      }
                    })
    }
  },
  CommentData: state => {
    return state.UserComment
  },
  SelectedContenttab: state => state.SelectedContenttab,
  ContentPageParent: state => state.ContentPage.Parent,
  ContentPages: state => state.ContentPage.ContentPages,
  NewContentPage: state => state.NewContentPage,
  ActiveCategory:state => state.ActiveCategory,
  POIMarkerAddressArr: state => state.POIMarkerAddressArr
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contentPages.js